




































import { Vue, Component, Prop } from 'vue-property-decorator';
import serverContextService from '@/core/serverContext.service';
import { EmployeeViewObject } from '@/types/apiServerContract';
import responsiveProductImageService from '@/project/product/image/responsiveProductImage.service';
import botService from '@/project/site/bot.service';

@Component
export default class EmployeeBlockItem extends Vue {
    @Prop()
    content!: EmployeeViewObject;

    @Prop({ type: Number, default: 0 })
    index!:number;

    @Prop({ type: Boolean, default: true })
    showImagePlaceholderIfEmpty!:number;

    @Prop({ type: String, default: 'mb-5' })
    textLineClass!:string;

    @Prop({ type: String, default: 'mb-5' })
    nameLineClass!:string;

    @Prop({ type: String, default: 'mb-5' })
    titleLineClass!:string;

    get missingImageStyle(): Partial<CSSStyleDeclaration> {
        const colors: string[] = !serverContextService.isOprema ? ['#c5d2e0', '#c9c0b7', '#9dbcb0'] : ['#fffef2', '#abd3df', '#ededed'];
        const styles: Partial<CSSStyleDeclaration> = {
            backgroundColor: colors[this.index % colors.length]
        };
        return styles;
    }

    private get getLargeImage(): string | null {
        return this.content && this.content.photoUrl ? responsiveProductImageService.formatImageUrl(this.content.photoUrl, '256') : null;
    }

    private get getSmallImage(): string | null {
        return this.content && this.content.photoUrl ? responsiveProductImageService.formatImageUrl(this.content.photoUrl, '128') : null;
    }

    private get showEmail(): boolean {
        return !!(this.content.email && !this.isBot);
    }

    private get isBot(): boolean {
        return botService.uaIsBot() || botService.uaIsPrerender();
    }

    private get showImage():boolean {
        return !!(this.showImagePlaceholderIfEmpty || this.getSmallImage);
    }
}
